<template>
  <div>
    <!--  -->
    <!-- <div v-if="inspectie">
      <b-input-group prepend="prijspeil">
         <b-input 
          v-model.number="inspectie.inspectie.config.prijspeil" 
          disabled
          type="number" />
      </b-input-group> 
       <Matrix
        v-if="false"
        :config="inspectie.inspectie.config"
        :mods="inspectie.inspectie.moderators"
        :onderdelen="inspectie.inspectie.onderdelen"
        :header-rows="[]"
        :fotoboek="[]"
        :bouwjaar="bouwjaar"
        :elementen="elementen"
        :inventarisatie="{}"
      /> 
    </div>-->
    
    <div v-if="inspectie && elementen">
      <table>
        <caption top>
          Prijspeil {{ inspectie.inspectie.config.prijspeil }}
        </caption>
        <thead>
          <tr>
            <th 
              v-for="(th,key) in getPrognoseResultaat(rows).totalen" 
              :key="key"
            >
              {{ key }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              v-for="(th,key) in getPrognoseResultaat(rows).totalen" 
              :key="key"
            >
              {{ th }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-input-group>
        <b-input-group-text>
          {{ url }}
        </b-input-group-text>
        <b-button @click="indexeerPrognoseBy(index,new Date().getFullYear())">
          Indexeer met {{ index }}
        </b-button>
      </b-input-group>
    </div>
  </div>
</template>

<script>
    import { serviceMixin } from "@/mixins/serviceMixin";
    import { prognoseMixin } from "@/mixins/prognoseMixin";
    import Matrix from '../views/prognoses/Matrix.vue';

    export default {
        name: 'PrognoseResultaat',
        components: { Matrix },
        mixins: [ serviceMixin, prognoseMixin ],
        props: {
            url: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            elementen: {
                type: Object,
                required: true
            },
        },
        setup() {
            return {};
        },
        data() {
            return  {
                inspectie: null,
            }
        },
        watch: {},
        mounted () {
            this.loadPrognose()
        },
        methods: {
            loadPrognose() {
                var vm = this;
                this.get(this.url)
                    .then(function (response) {
                        console.dir(response.data);
                        vm.inspectie = response.data;
                        vm.onderdelen = response.data.inspectie.onderdelen;
                        vm.inventarisatie = response.data.inventarisatie;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                },
        },
            
    }
</script>